import React, {Component} from 'react';
import MediaQuery from 'react-responsive';
import PopupPlayer from './PopupPlayer';
import PreviewPlayer from './PreviewPlayer';

interface PopupPlayerContainerProps {
    previewVideoXsId: string;
    previewVideoXsAspectRatio: string;
    previewVideoId: string;
    previewVideoAspectRatio: string;
    mainVideoId: string;
    mainVideoAspectRatio: string;
    mainVideoDownloadUrl: string;
}

export default class PreviewAndPopupPlayerContainer
extends Component<PopupPlayerContainerProps> {
    public state: {
        displayPopup: boolean
    };

    public constructor(props: PopupPlayerContainerProps) {
        super(props);
        this.handlePopupOpenClick = this.handlePopupOpenClick.bind(this);
        this.handlePopupCloseClick = this.handlePopupCloseClick.bind(this);
        this.state = {displayPopup: false};
    }

    public render() {
        const downloadUrl = this.props.mainVideoDownloadUrl ||
            ''
        return <div>
            <MediaQuery minWidth={768}>
                <PreviewPlayer videoId={this.props.previewVideoId}
                               aspectRatio={this.props.previewVideoAspectRatio}
                               onClick={this.handlePopupOpenClick}/>
            </MediaQuery>
            <MediaQuery maxWidth={767}>
                <PreviewPlayer videoId={this.props.previewVideoXsId}
                               aspectRatio={this.props.previewVideoXsAspectRatio}
                               onClick={this.handlePopupOpenClick}/>
            </MediaQuery>
            {this.state.displayPopup &&
            <PopupPlayer videoId={this.props.mainVideoId}
                         aspectRatio={this.props.mainVideoAspectRatio}
                         onClose={this.handlePopupCloseClick}
                         downloadUrl={this.props.mainVideoDownloadUrl}/>
            }
        </div>;
    }

    private handlePopupOpenClick() {
        this.setState({displayPopup: true});
    }

    private handlePopupCloseClick() {
        this.setState({displayPopup: false});
    }
}
